import { render, staticRenderFns } from "./commodityPigStage.vue?vue&type=template&id=cc021e4e&scoped=true&"
import script from "./commodityPigStage.vue?vue&type=script&lang=js&"
export * from "./commodityPigStage.vue?vue&type=script&lang=js&"
import style0 from "./commodityPigStage.vue?vue&type=style&index=0&id=cc021e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc021e4e",
  null
  
)

export default component.exports